<template lang="">
    <div class="chartmode" ref="chartRef">

    </div>
</template>
<script>
import { Chart } from '@antv/g2';
export default {
    data() {
        return {
            data: [
                { genre: '1月', sold: 130 },
                { genre: '2月', sold: 150 },
                { genre: '3月', sold: 100 },
                { genre: '4月', sold: 50 },
                { genre: '5月', sold: 150 },
                { genre: '6月', sold: 80 },
            ],
            chart: null,
        }
    },
    created() {

    },
    mounted() {
        this.chart = this.renderBarChart(this.$refs.chartRef, this.data);
    },
    methods: {
        // 渲染条形图
        renderBarChart(container, data) {
            const chart = new Chart({
                container,
                autoFit: true,
                padding: 0
            });

            // 声明可视化
            chart
                .interval() // 创建一个 Interval 标记
                .data(data) // 绑定数据
                .encode('x', 'genre') // 编码 x 通道
                .encode('y', 'sold') // 编码 y 通道
                .encode('key', 'genre') // 指定 key
                .animate('update', { duration: 300 })
                .axis('x', {
                    label:false,
                    title:false,
                    line:false,
                    tick:false
                })
                .axis('y', {
                    label:false,
                    title:false,
                    line:false,
                    tick:false
                }); // 指定更新动画的时间

            // 渲染可视化
            chart.render();
            return chart;
        }
    }
}
</script>
<style lang="less">
.chartmode {
    width: 100%;
    height: 100%;
}
</style>